<template>
  <el-menu
    :default-active="$route.path"
    background-color="#232c3b"
    text-color="#A0ACB9"
    active-text-color="#fff"
    router
    unique-opened
  >
    <MenuItem :routes="routes" />
  </el-menu>
</template>

<script>
import { mapState } from 'vuex'
import MenuItem from './menu_item.vue'

export default {
  components: { MenuItem },
  data() {
    return {}
  },
  methods: {},
  computed: {
    ...mapState({ routes: (state) => state.routes.allowRoutes })
  }
}
</script>

<style lang='scss' scoped>
</style>
